var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"pill":""},on:{"click":function($event){return _vm.showPrintOption()}}},[_c('printer-icon',{attrs:{"title":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }